import React from "react";

import { Tooltip } from "@components/tooltip-container";
import { useAdoptedBudgetMix } from "@features/mmm/hooks/use-adopted-budget-mix";

import { usePerformanceTrackingSummary } from "../hooks/use-performance-tracking-summary";
import { PerformanceTrackingSetting } from "../setting/performance-tracking-setting";

import { DerivedKpiTile } from "./derived-kpi-tile/derived-kpi-tile";
import { KpiTile } from "./kpi-tile";
import { SpendTile } from "./spend-tile";

export function PerformanceTrackingTargets() {
  const { summary } = usePerformanceTrackingSummary();
  const { adoptedBudgetMix } = useAdoptedBudgetMix();

  return (
    <>
      <div className="text-xl font-semibold">
        Budget Mix: {adoptedBudgetMix?.name}
      </div>
      <div className="flex space-x-4">
        <PerformanceTrackingSetting />
      </div>
      <div className="border-b border-b-v2-tertiary -mx-6"></div>
      <div className="text-xl font-semibold">
        Pacing
        <Tooltip
          content={
            <div className="w-[540px]">
              <p>
                MMM+ forecasts KPI performance before a media mix begins. It is
                calculated as both a total target range for the entire period
                and as a weekly forecast. Weekly forecasts are not equal
                distributions of the total but rather vary week to week. Any
                daily figures are derived from the daily average of the weekly
                forecast.
              </p>
              <p>
                Importantly, the forecast assumes spend recommendations are
                followed throughout the mix cycle. It is not updated in real
                time to reflect deviations in spend.
              </p>
              Learn more about breakdowns in the{" "}
              <a
                href="https://info.northbeam.io/knowledge/get-started-with-mmm"
                target="_blank"
                rel="noreferrer"
              >
                Northbeam Knowledge Base
              </a>
              .
            </div>
          }
        />
      </div>
      <div className="grid gap-4 grid-cols-[2fr_2fr_1.5fr] min-w-0">
        <SpendTile data={summary?.spend} />
        <KpiTile data={summary?.kpi} />
        <DerivedKpiTile spend={summary?.spend} kpi={summary?.kpi} />
      </div>
    </>
  );
}
